<template>
  <div class="thankyou-container">
    <div class="w100">
      <wrap-container class="thankYouOtp-container">
        <div class="padded">
          <img class="cardImage" :src="cardImage" alt="Tarjeta" />
          <h1 class="title medium">
            ¡Listo! <br />
            Ahora queda esperar tu tarjeta
          </h1>
          <p class="text">
            Te enviaremos tu tarjeta dentro de los próximos 10 días hábiles a
            <span data-obfuscate>{{ domicilio }}</span>
          </p>
          <p class="text">
            Recibirás el detalle de tu solicitud en
            <span data-obfuscate class="email">{{ email }}</span>
          </p>
        </div>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import { provincias } from "@/config/constants";
export default {
  name: "ThankYouCard",
  components: {
    WrapContainer
  },
  computed: {
    email() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.email) {
        return consulta.email;
      }
      return "";
    },
    domicilio() {
      const domicilio = this.$store.getters.getDatosPersonales();
      if (domicilio.domicilioParticular.calle) {
        const calle = domicilio.domicilioParticular.calle;
        const altura = domicilio.domicilioParticular.numero;
        const localidad = domicilio.domicilioParticular.localidad;
        const provincia = provincias.filter(
          prov => prov.value === domicilio.domicilioParticular.provincia
        );
        return `${calle} ${altura}, ${localidad}, ${provincia[0].label}`;
      }

      return "";
    }
  },
  data() {
    return {
      cardImage: require("../assets/img/1x/card-check.svg")
    };
  }
};
</script>

<style scoped>
div.thankyou-container {
  color: white;
  text-align: left;
  background: #003165;
  padding: 30px;
}
.thankYouOtp-container {
  color: white;
}
.laptopImage {
  width: 70px;
}
.title {
  font-size: 26px;
  line-height: 1.3em;
  margin-top: 0;
}
.cardImage {
  width: 160px;
  margin: 0;
}
.text {
  font-size: 15px;
  line-height: 1.6em;
}
.email {
  font-weight: bold;
}
</style>
